import { Injectable } from '@angular/core';
import { UsersTypes } from 'src/app/_enums';

@Injectable({
  providedIn: 'root'
})
export class MainService {
  public currentUser: any;
  public UserTypes = UsersTypes;
  public menuList: any;
  constructor() {
    this.menuInit();
  }
  menuInit(): void {
    this.currentUser = JSON.parse(localStorage.getItem('currentUser'));
    this.menuList = {
      IsOpen: false,
      ActivePage: -1,
      ActivePageSecond: -1,
      ActivePageThird: -1,
      ActiveNested: -1,
      HoveredPage: -1,
      disabled: false,
      Menu: [
        {
          id: 0,
          Icon: 'Dashboard' + '.png',
          PageName: 'Dashboard',
          RouteName: 'Home',
          Decription: null,
          Hovering: false,
          IsNested: false,
          IsOpen: false,
          IsActive: true,
          PageIndex: 0,
          SecondPageIndex: -1,
          ThirdPageIndex: -1,
          disabled: false,
          Menu: []
        },
        {
          id: 1,
          Icon: 'UsersCog' + '.png',
          PageName: 'Users',
          RouteName: 'Home/Users/Dashboard',
          Decription: null,
          Hovering: false,
          IsNested: false,
          IsOpen: false,
          IsActive: false,
          PageIndex: 1,
          SecondPageIndex: -1,
          ThirdPageIndex: -1,
          disabled: this.currentUser.userType === this.UserTypes.Teacher,
          Menu: []
        },
        {
          id: 2,
          Icon: 'BoardStudents' + '.png',
          PageName: 'Classes',
          RouteName: 'Home/Classes',
          Decription: null,
          Hovering: false,
          IsNested: false,
          IsOpen: false,
          IsActive: false,
          PageIndex: 2,
          SecondPageIndex: -1,
          ThirdPageIndex: -1,
          disabled: false,
          Menu: []
        },
        {
          id: 3,
          Icon: 'BooksChart' + '.png',
          PageName: 'Academic',
          RouteName: null,
          Decription: null,
          Hovering: false,
          IsNested: true,
          IsOpen: false,
          IsActive: true,
          PageIndex: 3,
          SecondPageIndex: -1,
          ThirdPageIndex: -1,
          disabled: false,
          Menu: [
            {
              id: 14,
              Icon: 'AcademicYear' + '.png',
              PageName: 'SettingsModule.AcademicYear',
              RouteName: 'Home/SystemSettings/ManageAcademicYear',
              Hovering: false,
              IsNested: false,
              IsOpen: false,
              IsActive: true,
              PageIndex: 3,
              SecondPageIndex: 0,
              ThirdPageIndex: -1,
              disabled: this.currentUser.userType === this.UserTypes.Teacher,
              Menu: []
            },
            {
              id: 11,
              Icon: 'open-book-2' + '.png',
              PageName: 'SettingsModule.SubjectsManagemnt',
              RouteName: 'Home/SystemSettings/SubjectsManagement',
              Hovering: false,
              IsNested: false,
              IsOpen: false,
              IsActive: true,
              PageIndex: 3,
              SecondPageIndex: 0,
              ThirdPageIndex: -1,
              disabled: this.currentUser.userType === this.UserTypes.Teacher,
              Menu: []
            },
            {
              id: 0,
              Icon: 'lesson' + '.png',
              PageName: 'SettingsModule.ManageAcademics',
              RouteName: 'Home/SystemSettings/AcademicsManage',
              Hovering: false,
              IsNested: false,
              IsOpen: false,
              IsActive: true,
              PageIndex: 3,
              SecondPageIndex: 0,
              ThirdPageIndex: -1,
              disabled: this.currentUser.userType === this.UserTypes.Teacher,
              Menu: []
            },
            // {
            //   id: 15,
            //   Icon: 'UsersBig' + '.png',
            //   PageName: 'UsersManagement',
            //   RouteName: 'Home/Users/Dashboard',
            //   Hovering: false,
            //   IsNested: false,
            //   IsOpen: false,
            //   IsActive: true,
            //   PageIndex: 3,
            //   SecondPageIndex: 0,
            //   ThirdPageIndex: -1,
            //   disabled: false,
            //   Menu: []
            // },
            {
              id: 0,
              Icon: 'CalenderGreen' + '.png',
              PageName: 'StudyTables',
              RouteName: 'Home/Academic/Timetable/ViewSchedule',
              Hovering: false,
              IsNested: false,
              IsOpen: false,
              IsActive: true,
              PageIndex: 3,
              SecondPageIndex: 0,
              ThirdPageIndex: -1,
              disabled: false,
              Menu: [
                {
                  id: 0,
                  Icon: null,
                  PageName: 'ViewSchedule',
                  RouteName: 'Home/Academic/Attendance/ViewSchedule',
                  Hovering: false,
                  IsNested: false,
                  IsOpen: false,
                  IsActive: false,
                  PageIndex: 3,
                  SecondPageIndex: 0,
                  ThirdPageIndex: 0,
                  disabled: false,
                  Menu: []
                },
                {
                  id: 2,
                  Icon: null,
                  PageName: 'Schedules Tracking',
                  RouteName: 'Home/Academic/Attendance/SchedulesTracking',
                  Hovering: false,
                  IsNested: false,
                  IsOpen: false,
                  IsActive: false,
                  PageIndex: 3,
                  SecondPageIndex: 0,
                  ThirdPageIndex: 2,
                  disabled: false,
                  Menu: []
                }
              ]
            },
            {
              id: 2,
              Icon: 'Books' + '.png',
              PageName: 'LearningPath0To1',
              RouteName: 'Home/Academic/LearningPath',
              Hovering: false,
              IsNested: false,
              IsOpen: false,
              IsActive: true,
              PageIndex: 3,
              SecondPageIndex: 2,
              ThirdPageIndex: -1,
              disabled: false,
              Menu: [
                {
                  id: 0,
                  Icon: null,
                  PageName: 'Subjects',
                  RouteName: 'Home/Academic/Attendance/Subjects',
                  Hovering: false,
                  IsNested: false,
                  IsOpen: false,
                  IsActive: false,
                  PageIndex: 3,
                  SecondPageIndex: 2,
                  ThirdPageIndex: 0,
                  disabled: false,
                  Menu: []
                },
                {
                  id: 1,
                  Icon: null,
                  PageName: 'Classes',
                  RouteName: 'Home/Academic/Attendance/Allocations',
                  Hovering: false,
                  IsNested: false,
                  IsOpen: false,
                  IsActive: false,
                  PageIndex: 3,
                  SecondPageIndex: 2,
                  ThirdPageIndex: 1,
                  disabled: false,
                  Menu: []
                },
                {
                  id: 2,
                  Icon: null,
                  PageName: 'Elective Subjects Allowcations',
                  RouteName: 'Home/Academic/Attendance/SchedulesTracking',
                  Hovering: false,
                  IsNested: false,
                  IsOpen: false,
                  IsActive: false,
                  PageIndex: 3,
                  SecondPageIndex: 2,
                  ThirdPageIndex: 2,
                  disabled: false,
                  Menu: []
                }
              ]
            },
            {
              id: 5,
              Icon: 'Grading&Assessments' + '.png',
              PageName: 'Grading&Assessments',
              RouteName: 'Home/Academic/GradingAndAssessments/GradingBook',
              Hovering: false,
              IsNested: false,
              IsOpen: false,
              IsActive: true,
              PageIndex: 3,
              SecondPageIndex: 5,
              ThirdPageIndex: -1,
              disabled: false,
              Menu: []
            },
            {
              id: 16,
              Icon: 'report' + '.png',
              PageName: 'ReportsCards',
              RouteName: 'Home/Academic/ReportsCards/ReportCard',
              Hovering: false,
              IsNested: false,
              IsOpen: false,
              IsActive: true,
              PageIndex: 3,
              SecondPageIndex: 9,
              ThirdPageIndex: -1,
              disabled: false,
              Menu: []
            },
            {
              id: 3,
              Icon: 'CheckOclock' + '.png',
              PageName: 'Plans.Plans',
              RouteName: 'Home/Academic/Plans',
              Hovering: false,
              IsNested: false,
              IsOpen: false,
              IsActive: true,
              PageIndex: 3,
              SecondPageIndex: 3,
              ThirdPageIndex: -1,
              disabled: false,
              Menu: []
            },
            {
              id: 10,
              Icon: 'QuestionsBank' + '.png',
              PageName: 'QuestionsBank.QuestionsBank',
              RouteName: 'Home/Academic/QuestionsBank',
              Hovering: false,
              IsNested: false,
              IsOpen: false,
              IsActive: true,
              PageIndex: 3,
              SecondPageIndex: 10,
              ThirdPageIndex: -1,
              disabled: false,
              Menu: []
            },
            {
              id: 1,
              Icon: 'CheckUser' + '.png',
              PageName: 'Attendance',
              RouteName: 'Home/Academic/Attendance/Register',
              Hovering: false,
              IsNested: false,
              IsOpen: false,
              IsActive: true,
              PageIndex: 3,
              SecondPageIndex: 1,
              ThirdPageIndex: 0,
              disabled: false,
              Menu: [
                {
                  id: 0,
                  Icon: null,
                  PageName: 'Register',
                  RouteName: 'Home/Academic/Attendance/Register',
                  Hovering: false,
                  IsNested: false,
                  IsOpen: false,
                  IsActive: false,
                  PageIndex: 3,
                  SecondPageIndex: 1,
                  ThirdPageIndex: 0,
                  disabled: false,
                  Menu: []
                },
                {
                  id: 1,
                  Icon: null,
                  PageName: 'Today-Wise',
                  RouteName: 'Home/Academic/Attendance/TodayWise',
                  Hovering: false,
                  IsNested: false,
                  IsOpen: false,
                  IsActive: false,
                  PageIndex: 3,
                  SecondPageIndex: 1,
                  ThirdPageIndex: 1,
                  disabled: false,
                  Menu: []
                },
                {
                  id: 2,
                  Icon: null,
                  PageName: 'View-Wise',
                  RouteName: 'Home/Academic/Attendance/ViewWise',
                  Hovering: false,
                  IsNested: false,
                  IsOpen: false,
                  IsActive: false,
                  PageIndex: 3,
                  SecondPageIndex: 1,
                  ThirdPageIndex: 2,
                  disabled: false,
                  Menu: []
                },
                {
                  id: 3,
                  Icon: null,
                  PageName: 'Submission Analytics',
                  RouteName: 'Home/Academic/Attendance/SubmissionAnalytics',
                  Hovering: false,
                  IsNested: false,
                  IsOpen: false,
                  IsActive: false,
                  PageIndex: 3,
                  SecondPageIndex: 1,
                  ThirdPageIndex: 4,
                  disabled: false,
                  Menu: []
                },
                {
                  id: 4,
                  Icon: null,
                  PageName: 'Statistics',
                  RouteName: 'Home/Academic/Attendance/Statistics',
                  Hovering: false,
                  IsNested: false,
                  IsOpen: false,
                  IsActive: false,
                  PageIndex: 3,
                  SecondPageIndex: 1,
                  ThirdPageIndex: 5,
                  disabled: false,
                  Menu: []
                },
                {
                  id: 5,
                  Icon: null,
                  PageName: 'Settings',
                  RouteName: 'Home/Academic/Attendance/Settings',
                  Hovering: false,
                  IsNested: false,
                  IsOpen: false,
                  IsActive: false,
                  PageIndex: 3,
                  SecondPageIndex: 1,
                  ThirdPageIndex: 6,
                  disabled: false,
                  Menu: []
                }
              ]
            },
            {
              id: 8,
              Icon: 'medal' + '.png',
              PageName: 'Evaluation',
              RouteName: 'Home/Academic/Evaluations/EvaluationsManage',
              Hovering: false,
              IsNested: false,
              IsOpen: false,
              IsActive: true,
              PageIndex: 3,
              SecondPageIndex: 8,
              ThirdPageIndex: -1,
              disabled: false,
              Menu: []
            },
            {
              id: 9,
              Icon: 'Notes' + '.png',
              PageName: 'Notes',
              RouteName: 'Home/Academic/Notes/ViewNotes',
              Hovering: false,
              IsNested: false,
              IsOpen: false,
              IsActive: true,
              PageIndex: 3,
              SecondPageIndex: 9,
              ThirdPageIndex: -1,
              disabled: false,
              Menu: []
            },
            // {
            //   id: 20,
            //   Icon: 'lecture' + '.png',
            //   PageName: 'SectionSummary',
            //   RouteName: 'Home/Classes/Students',
            //   Hovering: false,
            //   IsNested: false,
            //   IsOpen: false,
            //   IsActive: true,
            //   PageIndex: 3,
            //   SecondPageIndex: 9,
            //   ThirdPageIndex: -1,
            //   disabled: false,
            //   Menu: []
            // },
            {
              id: 9,
              Icon: 'health' + '.png',
              PageName: 'HealthRecords',
              RouteName: 'Home/Academic/HealthRecords',
              Hovering: false,
              IsNested: false,
              IsOpen: false,
              IsActive: true,
              PageIndex: 3,
              SecondPageIndex: 9,
              ThirdPageIndex: -1,
              disabled: false,
              Menu: []
            },
            {
              id: 26,
              Icon: 'lecture' + '.png',
              PageName: 'SectionSummary',
              RouteName: 'Home/Classes/Students',
              Hovering: false,
              IsNested: false,
              IsOpen: false,
              IsActive: true,
              PageIndex: 3,
              SecondPageIndex: 5,
              ThirdPageIndex: -1,
              disabled: false,
              Menu: []
            },
            {
              id: 25,
              Icon: 'UsersBig' + '.png',
              PageName: 'UsersManagement',
              RouteName: 'Home/Users/Dashboard',
              Hovering: false,
              IsNested: false,
              IsOpen: false,
              IsActive: true,
              PageIndex: 3,
              SecondPageIndex: 5,
              ThirdPageIndex: -1,
              disabled: false,
              Menu: []
            },
            {
              id: 27,
              Icon: 'q8-min' + '.png',
              PageName: 'Settings',
              RouteName: 'Home/SystemSettings/SchoolSettings',
              Hovering: false,
              IsNested: false,
              IsOpen: false,
              IsActive: true,
              PageIndex: 3,
              SecondPageIndex: 5,
              ThirdPageIndex: -1,
              disabled: false,
              Menu: []
            },
            // {
            //   id: 0,
            //   Icon: 'Registration' + '.png',
            //   PageName: 'Per-Admissions',
            //   RouteName: '',
            //   Hovering: false,
            //   IsNested: false,
            //   IsOpen: false,
            //   IsActive: true,
            //   PageIndex: 3,
            //   SecondPageIndex: 0,
            //   ThirdPageIndex: -1,
            //   disabled: true,
            //   Menu: []
            // },
            // {
            //   id: 4,
            //   Icon: 'strong-1' + '.png',
            //   PageName: 'SpecialNeedEducation',
            //   RouteName: 'Home/Academic/Attendance/Homeworks',
            //   Hovering: false,
            //   IsNested: false,
            //   IsOpen: false,
            //   IsActive: true,
            //   PageIndex: 3,
            //   SecondPageIndex: 4,
            //   ThirdPageIndex: -1,
            //   disabled: true,
            //   Menu: []
            // },
            // {
            //   id: 6,
            //   Icon: 'Grading&Assessments' + '.png',
            //   PageName: 'ReportsCards',
            //   RouteName: 'Home/Academic/GradingAndAssessments/GradingBook',
            //   Hovering: false,
            //   IsNested: false,
            //   IsOpen: false,
            //   IsActive: true,
            //   PageIndex: 3,
            //   SecondPageIndex: 6,
            //   ThirdPageIndex: -1,
            // disabled:false,
            // Menu: []
            // },
            {
              id: 9,
              Icon: 'manager-1.png',
              PageName: 'AdvisoryWorks',
              RouteName: 'Home/Academic/AdvisoryWorks/AdvisoryAttendance',
              Hovering: false,
              IsNested: false,
              IsOpen: false,
              IsActive: true,
              PageIndex: 3,
              SecondPageIndex: 8,
              ThirdPageIndex: -1,
              disabled: false,
              Menu: []
            },
            {
              id: 11,
              Icon: 'SmartClasses' + '.png',
              PageName: 'SmartClasses',
              RouteName: 'Home/Academic/Attendance/QuestionsBank',
              Hovering: false,
              IsNested: false,
              IsOpen: false,
              IsActive: true,
              PageIndex: 3,
              SecondPageIndex: 11,
              ThirdPageIndex: -1,
              disabled: true,
              Menu: []
            },
            // {
            //   id: 7,
            //   Icon: 'Supporting&NeedsEducation' + '.png',
            //   PageName: 'TrainingCourse',
            //   RouteName: 'Home/Academic/Attendance/Certificates',
            //   Hovering: false,
            //   IsNested: false,
            //   IsOpen: false,
            //   IsActive: true,
            //   PageIndex: 3,
            //   SecondPageIndex: 7,
            //   ThirdPageIndex: -1,
            //   disabled: true,
            //   Menu: []
            // },
            {
              id: 1,
              Icon: 'graduation' + '.png',
              PageName: 'Graduation',
              RouteName: '',
              Hovering: false,
              IsNested: false,
              IsOpen: false,
              IsActive: true,
              PageIndex: 3,
              SecondPageIndex: 1,
              ThirdPageIndex: -1,
              disabled: true,
              Menu: []
            },
            {
              id: 10,
              Icon: 'ic-man-4.png',
              PageName: 'SupervisoryWorks',
              RouteName: '',
              Hovering: false,
              IsNested: false,
              IsOpen: false,
              IsActive: true,
              PageIndex: 3,
              SecondPageIndex: 8,
              ThirdPageIndex: -1,
              disabled: true,
              Menu: []
            },
            // {
            //   id: 11,
            //   Icon: 'ic-cup-2' + '.png',
            //   PageName: 'TalentsManagement',
            //   RouteName: '',
            //   Hovering: false,
            //   IsNested: false,
            //   IsOpen: false,
            //   IsActive: true,
            //   PageIndex: 3,
            //   SecondPageIndex: 8,
            //   ThirdPageIndex: -1,
            //   disabled: true,
            //   Menu: []
            // },

            {
              id: 12,
              Icon: 'Courses' + '.png',
              PageName: 'Courses',
              RouteName: 'Home/Academic/Attendance/Courses',
              Hovering: false,
              IsNested: false,
              IsOpen: false,
              IsActive: false,
              PageIndex: 3,
              SecondPageIndex: 12,
              ThirdPageIndex: -1,
              disabled: false,
              Menu: []
            }
          ]
        },
        {
          id: 4,
          Icon: 'Handbag' + '.png',
          PageName: 'Managerial',
          RouteName: null,
          Decription: null,
          Hovering: false,
          IsNested: true,
          IsOpen: false,
          IsActive: true,
          PageIndex: 4,
          SecondPageIndex: -1,
          ThirdPageIndex: -1,
          disabled: false,
          Menu: [
            {
              id: 1,
              Icon: 'Finance' + '.png',
              PageName: 'Finance',
              RouteName: '',
              Hovering: false,
              IsNested: false,
              IsOpen: false,
              IsActive: true,
              PageIndex: 4,
              SecondPageIndex: 1,
              ThirdPageIndex: -1,
              disabled: true,
              Menu: []
            },
            {
              id: 2,
              Icon: 'notebook-1' + '.png',
              PageName: 'GeneralLedger',
              RouteName: '',
              Hovering: false,
              IsNested: false,
              IsOpen: false,
              IsActive: true,
              PageIndex: 4,
              SecondPageIndex: 1,
              ThirdPageIndex: -1,
              disabled: true,
              Menu: []
            },
            {
              id: 3,
              Icon: 'budget' + '.png',
              PageName: 'Budgeting',
              RouteName: '',
              Hovering: false,
              IsNested: false,
              IsOpen: false,
              IsActive: true,
              PageIndex: 4,
              SecondPageIndex: 1,
              ThirdPageIndex: -1,
              disabled: true,
              Menu: []
            },
            {
              id: 4,
              Icon: 'desk-chair' + '.png',
              PageName: 'FixedAssetsManagement',
              RouteName: '',
              Hovering: false,
              IsNested: false,
              IsOpen: false,
              IsActive: true,
              PageIndex: 4,
              SecondPageIndex: 1,
              ThirdPageIndex: -1,
              disabled: true,
              Menu: []
            },
            {
              id: 5,
              Icon: 'cheque' + '.png',
              PageName: 'ChequeCircle',
              RouteName: '',
              Hovering: false,
              IsNested: false,
              IsOpen: false,
              IsActive: true,
              PageIndex: 4,
              SecondPageIndex: 1,
              ThirdPageIndex: -1,
              disabled: true,
              Menu: []
            },
            {
              id: 6,
              Icon: 'analytics-8' + '.png',
              PageName: 'FinancialAuditing',
              RouteName: '',
              Hovering: false,
              IsNested: false,
              IsOpen: false,
              IsActive: true,
              PageIndex: 4,
              SecondPageIndex: 1,
              ThirdPageIndex: -1,
              disabled: true,
              Menu: []
            },
            {
              id: 7,
              Icon: 'StudentsPayments' + '.png',
              PageName: 'StudentsPayments',
              RouteName: '',
              Hovering: false,
              IsNested: false,
              IsOpen: false,
              IsActive: true,
              PageIndex: 4,
              SecondPageIndex: 2,
              ThirdPageIndex: -1,
              disabled: true,
              Menu: []
            },
            {
              id: 8,
              Icon: 'OnlinePayment' + '.png',
              PageName: 'E-Commerce',
              RouteName: '',
              Hovering: false,
              IsNested: false,
              IsOpen: false,
              IsActive: true,
              PageIndex: 4,
              SecondPageIndex: 3,
              ThirdPageIndex: -1,
              disabled: true,
              Menu: []
            },
            {
              id: 9,
              Icon: 'charity-1' + '.png',
              PageName: 'Fundraising',
              RouteName: '',
              Hovering: false,
              IsNested: false,
              IsOpen: false,
              IsActive: true,
              PageIndex: 4,
              SecondPageIndex: 6,
              ThirdPageIndex: -1,
              disabled: true,
              Menu: []
            },
            {
              id: 10,
              Icon: 'banking' + '.png',
              PageName: 'SalesManagements',
              RouteName: '',
              Hovering: false,
              IsNested: false,
              IsOpen: false,
              IsActive: true,
              PageIndex: 4,
              SecondPageIndex: 6,
              ThirdPageIndex: -1,
              disabled: true,
              Menu: []
            },
            {
              id: 11,
              Icon: 'sell' + '.png',
              PageName: 'ProcurementManagement',
              RouteName: '',
              Hovering: false,
              IsNested: false,
              IsOpen: false,
              IsActive: true,
              PageIndex: 4,
              SecondPageIndex: 6,
              ThirdPageIndex: -1,
              disabled: true,
              Menu: []
            },
            {
              id: 12,
              Icon: 'HumanResources' + '.png',
              PageName: 'HumanResources',
              RouteName: '',
              Hovering: false,
              IsNested: false,
              IsOpen: false,
              IsActive: true,
              PageIndex: 4,
              SecondPageIndex: 4,
              ThirdPageIndex: -1,
              disabled: true,
              Menu: []
            },
            {
              id: 13,
              Icon: 'money-10' + '.png',
              PageName: 'PayrollSystem',
              RouteName: '',
              Hovering: false,
              IsNested: false,
              IsOpen: false,
              IsActive: true,
              PageIndex: 4,
              SecondPageIndex: 4,
              ThirdPageIndex: -1,
              disabled: true,
              Menu: []
            },
            {
              id: 14,
              Icon: 'Inventory' + '.png',
              PageName: 'Inventory',
              RouteName: '',
              Hovering: false,
              IsNested: false,
              IsOpen: false,
              IsActive: true,
              PageIndex: 4,
              SecondPageIndex: 5,
              ThirdPageIndex: -1,
              disabled: true,
              Menu: []
            },
            {
              id: 15,
              Icon: 'Library' + '.png',
              PageName: 'Library',
              RouteName: '',
              Hovering: false,
              IsNested: false,
              IsOpen: false,
              IsActive: true,
              PageIndex: 4,
              SecondPageIndex: 8,
              ThirdPageIndex: -1,
              disabled: true,
              Menu: []
            },
            {
              id: 16,
              Icon: 'Transportations' + '.png',
              PageName: 'Transportations',
              RouteName: '',
              Hovering: false,
              IsNested: false,
              IsOpen: false,
              IsActive: true,
              PageIndex: 4,
              SecondPageIndex: 6,
              ThirdPageIndex: -1,
              disabled: true,
              Menu: []
            },
            {
              id: 17,
              Icon: 'PermissionsAndApprovals' + '.png',
              PageName: 'PermissionsAndApprovals',
              RouteName: '',
              Hovering: false,
              IsNested: false,
              IsOpen: false,
              IsActive: true,
              PageIndex: 4,
              SecondPageIndex: 14,
              ThirdPageIndex: -1,
              disabled: true,
              Menu: []
            },
            {
              id: 18,
              Icon: 'ActivitiesAndFacilities' + '.png',
              PageName: 'ActivitiesAndFacilities',
              RouteName: '',
              Hovering: false,
              IsNested: false,
              IsOpen: false,
              IsActive: true,
              PageIndex: 4,
              SecondPageIndex: 10,
              ThirdPageIndex: -1,
              disabled: true,
              Menu: []
            },
            {
              id: 19,
              Icon: 'Points&Partners' + '.png',
              PageName: 'Points&Partners',
              RouteName: '',
              Hovering: false,
              IsNested: false,
              IsOpen: false,
              IsActive: true,
              PageIndex: 4,
              SecondPageIndex: 13,
              ThirdPageIndex: -1,
              disabled: true,
              Menu: []
            },
            {
              id: 20,
              Icon: 'Hostel' + '.png',
              PageName: 'Hostel',
              RouteName: '',
              Hovering: false,
              IsNested: false,
              IsOpen: false,
              IsActive: true,
              PageIndex: 4,
              SecondPageIndex: 7,
              ThirdPageIndex: -1,
              disabled: true,
              Menu: []
            }
          ]
        },
        {
          id: 5,
          Icon: 'Users' + '.png',
          PageName: 'Communications',
          RouteName: 'Home/Communications/Events',
          Decription: null,
          Hovering: false,
          IsNested: true,
          IsOpen: false,
          IsActive: true,
          PageIndex: 5,
          SecondPageIndex: -1,
          ThirdPageIndex: -1,
          disabled: false,
          Menu: [
            {
              id: 0,
              Icon: 'ic-chat' + '.png',
              PageName: 'SMS',
              RouteName: 'Home/Communications/SMS',
              Hovering: false,
              IsNested: false,
              IsOpen: false,
              IsActive: true,
              PageIndex: 5,
              SecondPageIndex: 0,
              ThirdPageIndex: -1,
              disabled: this.currentUser.userType === this.UserTypes.Teacher,
              Menu: []
            },
            {
              id: 1,
              Icon: 'ic-mail-2' + '.png',
              PageName: 'Emails',
              RouteName: 'Home/Communications/Email',
              Hovering: false,
              IsNested: false,
              IsOpen: false,
              IsActive: true,
              PageIndex: 5,
              SecondPageIndex: 1,
              ThirdPageIndex: -1,
              disabled: this.currentUser.userType === this.UserTypes.Teacher,
              Menu: []
            },
            {
              id: 2,
              Icon: 'ic-notification' + '.png',
              PageName: 'NoticeBoard',
              RouteName: 'Home/Communications/Notice',
              Hovering: false,
              IsNested: false,
              IsOpen: false,
              IsActive: true,
              PageIndex: 5,
              SecondPageIndex: 2,
              ThirdPageIndex: -1,
              disabled: false,
              Menu: []
            },

            {
              id: 4,
              Icon: 'Gallery' + '.png',
              PageName: 'Gallery',
              RouteName: 'Home/Communications/Gallery',
              Hovering: false,
              IsNested: false,
              IsOpen: false,
              IsActive: true,
              PageIndex: 5,
              SecondPageIndex: 4,
              ThirdPageIndex: -1,
              disabled: false,
              Menu: []
            },
            {
              id: 9,
              Icon: 'ic-chating' + '.png',
              PageName: 'SocialLearning',
              RouteName: 'Home/Communications/SocialLearning',
              Hovering: false,
              IsNested: false,
              IsOpen: false,
              IsActive: true,
              PageIndex: 5,
              SecondPageIndex: 9,
              ThirdPageIndex: -1,
              disabled: false,
              Menu: []
            },
            {
              id: 6,
              Icon: 'ic-calnder-4' + '.png',
              PageName: 'Events',
              RouteName: 'Home/Communications/Events',
              Hovering: false,
              IsNested: false,
              IsOpen: false,
              IsActive: true,
              PageIndex: 5,
              SecondPageIndex: 6,
              ThirdPageIndex: -1,
              disabled: false,
              Menu: []
            },

            {
              id: 10,
              Icon: 'promotion-2-copy' + '.png',
              PageName: 'CommunicationModule.Circulars',
              RouteName: 'Home/Communications/Circulars',
              Hovering: false,
              IsNested: false,
              IsOpen: false,
              IsActive: true,
              PageIndex: 3,
              SecondPageIndex: 8,
              ThirdPageIndex: -1,
              disabled: false,
              Menu: []
            },

            {
              id: 5,
              Icon: 'ic-media' + '.png',
              PageName: 'News',
              RouteName: 'Home/Communications/News',
              Hovering: false,
              IsNested: false,
              IsOpen: false,
              IsActive: true,
              PageIndex: 5,
              SecondPageIndex: 5,
              ThirdPageIndex: -1,
              disabled: false,
              Menu: []
            },

            {
              id: 11,
              Icon: 'Calender' + '.png',
              PageName: 'Calender',
              RouteName: 'Home/Communications/Calender',
              Hovering: false,
              IsNested: false,
              IsOpen: false,
              IsActive: true,
              PageIndex: 5,
              SecondPageIndex: 11,
              ThirdPageIndex: -1,
              disabled: false,
              Menu: []
            },
            // {
            //   id: 7,
            //   Icon: 'E-Magazine' + '.png',
            //   PageName: 'E-Magazine',
            //   RouteName: 'Home/Communications/EMagazine',
            //   Hovering: false,
            //   IsNested: false,
            //   IsOpen: false,
            //   IsActive: true,
            //   PageIndex: 5,
            //   SecondPageIndex: 7,
            //   ThirdPageIndex: -1,
            //   disabled: true,
            //   Menu: []
            // },
            // {
            //   id: 23,
            //   Icon: 'Competitions' + '.png',
            //   PageName: 'Competitions',
            //   RouteName: 'Home/Communications/Competitions',
            //   Hovering: false,
            //   IsNested: false,
            //   IsOpen: false,
            //   IsActive: true,
            //   PageIndex: 5,
            //   SecondPageIndex: 23,
            //   ThirdPageIndex: -1,
            //   disabled: true,
            //   Menu: []
            // },
            // {
            //   id: 15,
            //   Icon: 'list' + '.png',
            //   PageName: 'Tasks',
            //   RouteName: 'Home/Communications/Tasks',
            //   Hovering: false,
            //   IsNested: false,
            //   IsOpen: false,
            //   IsActive: true,
            //   PageIndex: 5,
            //   SecondPageIndex: 15,
            //   ThirdPageIndex: -1,
            //   disabled: true,
            //   Menu: []
            // },
            // {
            //   id: 3,
            //   Icon: 'ic-cup' + '.png',
            //   PageName: 'Activites',
            //   RouteName: 'Home/Communications/Activities',
            //   Hovering: false,
            //   IsNested: false,
            //   IsOpen: false,
            //   IsActive: true,
            //   PageIndex: 5,
            //   SecondPageIndex: 3,
            //   ThirdPageIndex: -1,
            //   disabled: true,
            //   Menu: []
            // },
            // {
            //   id: 14,
            //   Icon: 'telemarketer' + '.png',
            //   PageName: 'Support',
            //   RouteName: 'Home/Communications/Support',
            //   Hovering: false,
            //   IsNested: false,
            //   IsOpen: false,
            //   IsActive: true,
            //   PageIndex: 5,
            //   SecondPageIndex: 14,
            //   ThirdPageIndex: -1,
            //   disabled: true,
            //   Menu: []
            // },
            // {
            //   id: 20,
            //   Icon: 'blogger-copy' + '.png',
            //   PageName: 'Blogs',
            //   RouteName: 'Home/Communications/Blogs',
            //   Hovering: false,
            //   IsNested: false,
            //   IsOpen: false,
            //   IsActive: true,
            //   PageIndex: 5,
            //   SecondPageIndex: 20,
            //   ThirdPageIndex: -1,
            //   disabled: true,
            //   Menu: []
            // },

            {
              id: 12,
              Icon: 'ic-meeting-2' + '.png',
              PageName: 'Meetings',
              RouteName: '',
              Hovering: false,
              IsNested: false,
              IsOpen: false,
              IsActive: true,
              PageIndex: 5,
              SecondPageIndex: 12,
              ThirdPageIndex: -1,
              disabled: true,
              Menu: []
            },
            // {
            //   id: 20,
            //   Icon: 'visitor' + '.png',
            //   PageName: 'Vistors',
            //   RouteName: '',
            //   Hovering: false,
            //   IsNested: false,
            //   IsOpen: false,
            //   IsActive: true,
            //   PageIndex: 5,
            //   SecondPageIndex: 13,
            //   ThirdPageIndex: -1,
            //   disabled: true,
            //   Menu: []
            // },
            // {
            //   id: 21,
            //   Icon: 'VotesAndSurvey' + '.png',
            //   PageName: 'VotesAndSurvey',
            //   RouteName: 'Home/Managerial/Votes/ManagePolls',
            //   Hovering: false,
            //   IsNested: false,
            //   IsOpen: false,
            //   IsActive: true,
            //   PageIndex: 5,
            //   SecondPageIndex: 12,
            //   ThirdPageIndex: -1,
            //   disabled: true,
            //   Menu: []
            // },
            {
              id: 22,
              Icon: 'Complaints' + '.png',
              PageName: 'Suggestions&Complaints',
              RouteName: '',
              Hovering: false,
              IsNested: false,
              IsOpen: false,
              IsActive: true,
              PageIndex: 5,
              SecondPageIndex: 11,
              ThirdPageIndex: -1,
              disabled: true,
              Menu: []
            },
            // {
            //   id: 23,
            //   Icon: 'Reminders' + '.png',
            //   PageName: 'Reminders',
            //   RouteName: '',
            //   Hovering: false,
            //   IsNested: false,
            //   IsOpen: false,
            //   IsActive: true,
            //   PageIndex: 5,
            //   SecondPageIndex: 15,
            //   ThirdPageIndex: -1,
            //   disabled: true,
            //   Menu: []
            // },
            // {
            //   id: 16,
            //   Icon: 'ic-game-3' + '.png',
            //   PageName: 'Games&FlashCards',
            //   RouteName: '',
            //   Hovering: false,
            //   IsNested: false,
            //   IsOpen: false,
            //   IsActive: true,
            //   PageIndex: 5,
            //   SecondPageIndex: 16,
            //   ThirdPageIndex: -1,
            //   disabled: true,
            //   Menu: []
            // },
            // {
            //   id: 22,
            //   Icon: 'Forms' + '.png',
            //   PageName: 'Forms',
            //   RouteName: '',
            //   Hovering: false,
            //   IsNested: false,
            //   IsOpen: false,
            //   IsActive: true,
            //   PageIndex: 5,
            //   SecondPageIndex: 22,
            //   ThirdPageIndex: -1,
            //   disabled: true,
            //   Menu: []
            // },
            // {
            //   id: 17,
            //   Icon: 'usb-1' + '.png',
            //   PageName: 'FlashCards',
            //   RouteName: '',
            //   Hovering: false,
            //   IsNested: false,
            //   IsOpen: false,
            //   IsActive: false,
            //   PageIndex: 5,
            //   SecondPageIndex: 17,
            //   ThirdPageIndex: -1,
            //   disabled: false,
            //   Menu: []
            // },
            {
              id: 18,
              Icon: 'Alumni' + '.png',
              PageName: 'Alumni',
              RouteName: '',
              Hovering: false,
              IsNested: false,
              IsOpen: false,
              IsActive: true,
              PageIndex: 3,
              SecondPageIndex: 8,
              ThirdPageIndex: -1,
              disabled: true,
              Menu: []
            }
            // {
            //   id: 19,
            //   Icon: 'search' + '.png',
            //   PageName: 'Google Documents',
            //   RouteName: '',
            //   Hovering: false,
            //   IsNested: false,
            //   IsOpen: false,
            //   IsActive: true,
            //   PageIndex: 5,
            //   SecondPageIndex: 19,
            //   ThirdPageIndex: -1,
            //   disabled: true,
            //   Menu: []
            // }
            // {
            //   id: 24,
            //   Icon: 'Users' + '.png',
            //   PageName: 'Guest',
            //   RouteName: '',
            //   Hovering: false,
            //   IsNested: false,
            //   IsOpen: false,
            //   IsActive: false,
            //   PageIndex: 5,
            //   SecondPageIndex: 21,
            //   ThirdPageIndex: -1,
            //   disabled: false,
            //   Menu: []
            // }
          ]
        },
        {
          id: 6,
          Icon: 'report' + '.png',
          PageName: 'ReportingStatistics',
          RouteName: 'Home/ReportingStatistics',
          Decription: null,
          Hovering: false,
          IsNested: true,
          IsOpen: false,
          IsActive: true,
          PageIndex: 6,
          SecondPageIndex: -1,
          ThirdPageIndex: -1,
          disabled: false,
          Menu: [
            {
              id: 3,
              Icon: 'ic-books-2' + '.png',
              PageName: 'Academic',
              RouteName: null,
              Decription: null,
              Hovering: false,
              IsNested: true,
              IsOpen: false,
              IsActive: true,
              PageIndex: 6,
              SecondPageIndex: -1,
              ThirdPageIndex: -1,
              disabled: true,
              Menu: []
            },
            {
              id: 4,
              Icon: 'ic-man-4-copy' + '.png',
              PageName: 'Managerial',
              RouteName: null,
              Decription: null,
              Hovering: false,
              IsNested: true,
              IsOpen: false,
              IsActive: true,
              PageIndex: 6,
              SecondPageIndex: -1,
              ThirdPageIndex: -1,
              disabled: true,
              Menu: []
            },
            {
              id: 5,
              Icon: 'ic-meeting-copy' + '.png',
              PageName: 'Communications',
              RouteName: 'Home/Communications/Events',
              Decription: null,
              Hovering: false,
              IsNested: true,
              IsOpen: false,
              IsActive: true,
              PageIndex: 5,
              SecondPageIndex: -1,
              ThirdPageIndex: -1,
              disabled: true,
              Menu: []
            },
            {
              id: 1,
              Icon: 'ic-tasks-copy' + '.png',
              PageName: 'Attendance',
              RouteName: '',
              Hovering: false,
              IsNested: false,
              IsOpen: false,
              IsActive: true,
              PageIndex: 3,
              SecondPageIndex: 1,
              ThirdPageIndex: 0,
              disabled: true,
              Menu: []
            },
            {
              id: 3,
              Icon: 'group-8' + '.png',
              PageName: 'CustomReports',
              RouteName: null,
              Decription: null,
              Hovering: false,
              IsNested: true,
              IsOpen: false,
              IsActive: true,
              PageIndex: 6,
              SecondPageIndex: -1,
              ThirdPageIndex: -1,
              disabled: true,
              Menu: []
            },
            {
              id: 13,
              Icon: 'sort-copy' + '.png',
              PageName: 'ComparsionReports',
              RouteName: null,
              Decription: null,
              Hovering: false,
              IsNested: true,
              IsOpen: false,
              IsActive: true,
              PageIndex: 6,
              SecondPageIndex: -1,
              ThirdPageIndex: -1,
              disabled: true,
              Menu: []
            },
            {
              id: 31,
              Icon: 'ic-user-4-copy-2' + '.png',
              PageName: 'UsersReports',
              RouteName: null,
              Decription: null,
              Hovering: false,
              IsNested: true,
              IsOpen: false,
              IsActive: true,
              PageIndex: 6,
              SecondPageIndex: -1,
              ThirdPageIndex: -1,
              disabled: true,
              Menu: []
            },
            {
              id: 31,
              Icon: 'ic-chat-copy' + '.png',
              PageName: 'Messaging',
              RouteName: null,
              Decription: null,
              Hovering: false,
              IsNested: true,
              IsOpen: false,
              IsActive: true,
              PageIndex: 6,
              SecondPageIndex: -1,
              ThirdPageIndex: -1,
              disabled: true,
              Menu: []
            },
            {
              id: 31,
              Icon: 'group-6' + '.png',
              PageName: 'ِApplications',
              RouteName: null,
              Decription: null,
              Hovering: false,
              IsNested: true,
              IsOpen: false,
              IsActive: true,
              PageIndex: 6,
              SecondPageIndex: -1,
              ThirdPageIndex: -1,
              disabled: true,
              Menu: []
            },
            {
              id: 31,
              Icon: 'ic-mony-1-copy' + '.png',
              PageName: 'Fees',
              RouteName: null,
              Decription: null,
              Hovering: false,
              IsNested: true,
              IsOpen: false,
              IsActive: true,
              PageIndex: 6,
              SecondPageIndex: -1,
              ThirdPageIndex: -1,
              disabled: true,
              Menu: []
            },
            {
              id: 9,
              Icon: 'health-copy' + '.png',
              PageName: 'HealthRecords',
              RouteName: '',
              Hovering: false,
              IsNested: false,
              IsOpen: false,
              IsActive: true,
              PageIndex: 3,
              SecondPageIndex: 9,
              ThirdPageIndex: -1,
              disabled: true,
              Menu: []
            },
            {
              id: 5,
              Icon: 'ic-marks-copy' + '.png',
              PageName: 'Grading&Assessments',
              RouteName: '',
              Hovering: false,
              IsNested: false,
              IsOpen: false,
              IsActive: true,
              PageIndex: 3,
              SecondPageIndex: 5,
              ThirdPageIndex: -1,
              disabled: true,
              Menu: []
            },
            {
              id: 5,
              Icon: 'ic-download-copy' + '.png',
              PageName: 'CustomImport',
              RouteName: '',
              Hovering: false,
              IsNested: false,
              IsOpen: false,
              IsActive: true,
              PageIndex: 3,
              SecondPageIndex: 5,
              ThirdPageIndex: -1,
              disabled: true,
              Menu: []
            },
            {
              id: 5,
              Icon: 'ic-download-copy-2' + '.png',
              PageName: 'DataExport',
              RouteName: '',
              Hovering: false,
              IsNested: false,
              IsOpen: false,
              IsActive: true,
              PageIndex: 3,
              SecondPageIndex: 5,
              ThirdPageIndex: -1,
              disabled: true,
              Menu: []
            },
            {
              id: 5,
              Icon: 'group-7' + '.png',
              PageName: 'DataManagement',
              RouteName: '',
              Hovering: false,
              IsNested: false,
              IsOpen: false,
              IsActive: true,
              PageIndex: 3,
              SecondPageIndex: 5,
              ThirdPageIndex: -1,
              disabled: true,
              Menu: []
            },
            {
              id: 5,
              Icon: 'registered-copy' + '.png',
              PageName: 'Audit',
              RouteName: '',
              Hovering: false,
              IsNested: false,
              IsOpen: false,
              IsActive: true,
              PageIndex: 3,
              SecondPageIndex: 5,
              ThirdPageIndex: -1,
              disabled: true,
              Menu: []
            }
            // {
            //   id: 5,
            //   Icon: 'report-3-copy' + '.png',
            //   PageName: 'Reports',
            //   RouteName: '',
            //   Hovering: false,
            //   IsNested: false,
            //   IsOpen: false,
            //   IsActive: true,
            //   PageIndex: 3,
            //   SecondPageIndex: 5,
            //   ThirdPageIndex: -1,
            //   disabled: false,
            //   Menu: []
            // },
          ]
        }
      ]
    };
  }
}
